import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: ReactNode;
  onClick?: () => void;
  className?: string;
}
export function CTAButton({
  children,
  onClick,
  className = ''
}: CTAButtonProps) {
  const scrollToPricing = () => {
    const target = document.getElementById('pricing-cta') || document.getElementById('pricing');
    target?.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.97
  }} onClick={onClick || scrollToPricing} className={`${`bg-cta text-white font-heading font-extrabold py-4 px-8 rounded-brand shadow-soft hover:bg-cta-hover transition-colors duration-200 text-lg w-full md:w-auto animate-pulse-cta cursor-pointer ${className}`} pt-[10px] pb-[10px]`} data-id="element-23">
      {children}
    </motion.button>;
}